export default __webpack_public_path__ + "static/media/(10).df06ad70.jpg";